/**
 * WHICH VENUE THIS OFFICE IS FOR: the link it was opened with (`?venue=`),
 * then the one this browser remembers, then the build's development default.
 * One build serves every venue; the onboarding prints each owner their link.
 */

const KEY = "gf.office.venue";
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

type Store = Pick<Storage, "getItem" | "setItem">;

const tryRead = (storage: Store | null): string | null => {
  try {
    return storage?.getItem(KEY) ?? null;
  } catch {
    return null;
  }
};

export function officeVenue(args: { search: string; storage: Store | null; fallback: string }): {
  venueId: string;
  fromLink: boolean;
} {
  const linked = new URLSearchParams(args.search).get("venue");
  if (linked && UUID.test(linked)) {
    try {
      args.storage?.setItem(KEY, linked);
    } catch {
      // Private mode: this visit still opens the venue it was linked to.
    }
    return { venueId: linked, fromLink: true };
  }
  const remembered = tryRead(args.storage);
  return { venueId: remembered && UUID.test(remembered) ? remembered : args.fallback, fromLink: false };
}
